/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scenarist_SccInputs */

const en_scenarist_scc = /** @type {(inputs: Scenarist_SccInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scenarist 1.0 (.scc)`)
};

const fr_scenarist_scc = /** @type {(inputs: Scenarist_SccInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scenarist 1.0 (.scc)`)
};

const de_scenarist_scc = /** @type {(inputs: Scenarist_SccInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scenarist 1.0 (.scc)`)
};

const it_scenarist_scc = /** @type {(inputs: Scenarist_SccInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scenarista 1.0 (.scc)`)
};

const ru_scenarist_scc = /** @type {(inputs: Scenarist_SccInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scenarist 1.0 (.scc)`)
};

const es_scenarist_scc = /** @type {(inputs: Scenarist_SccInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guionista 1.0 (.scc)`)
};

const zh_cn2_scenarist_scc = /** @type {(inputs: Scenarist_SccInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`场景 1.0 (.scc)`)
};

const ja_scenarist_scc = /** @type {(inputs: Scenarist_SccInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`シナリオリスト 1.0 (.scc)`)
};

const hi_scenarist_scc = /** @type {(inputs: Scenarist_SccInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सिनेरिस्ट 1.0 (.scc)`)
};

const pt_pt2_scenarist_scc = /** @type {(inputs: Scenarist_SccInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scenarist 1.0 (.scc)`)
};

/**
* | output |
* | --- |
* | "Scenarist 1.0 (.scc)" |
*
* @param {Scenarist_SccInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const scenarist_scc = /** @type {((inputs?: Scenarist_SccInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scenarist_SccInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_scenarist_scc(inputs)
	if (locale === "de") return de_scenarist_scc(inputs)
	if (locale === "it") return it_scenarist_scc(inputs)
	if (locale === "ru") return ru_scenarist_scc(inputs)
	if (locale === "es") return es_scenarist_scc(inputs)
	if (locale === "zh-CN") return zh_cn2_scenarist_scc(inputs)
	if (locale === "ja") return ja_scenarist_scc(inputs)
	if (locale === "hi") return hi_scenarist_scc(inputs)
	if (locale === "pt-PT") return pt_pt2_scenarist_scc(inputs)
	return en_scenarist_scc(inputs)
});